// this file is used as a fallback in case an optional package is not installed. see gatsby-node.js for more.

export default {}
